module.exports = __webpack_public_path__ + "static/asana-a157e8601e76d8b06e3c87499a57805b.svg";